/* eslint-disable no-console */
import { register } from "register-service-worker";
import Vue from "vue";
import MessagingService from "@/firebase/messageService";

if (process.env.NODE_ENV === "production") {
    register(`${process.env.BASE_URL}service-worker.js`, {
        async ready(registration) {
            if (Vue.prototype.$messaging) {
                Vue.prototype.$messaging.useServiceWorker(registration);
                const msgService = new MessagingService();
                //Request permission
                await msgService.requestPermissionAsync();
                //Retrieve token
                await msgService.getTokenAsync();
            }
        },
        cached() {
            console.log("Content has been cached for offline use.");
        },
        updatefound() {
            console.log("New content is downloading.");
        },
        updated() {
            console.log("New content is available; Refresh...");
            setTimeout(() => {
                window.location.reload(true);
            }, 1000);
        },
        offline() {
            console.log(
                "No internet connection found. App is running in offline mode."
            );
        },
        error(error) {
            console.error("Error during service worker registration:", error);
        }
    });
}
